import styled from '@emotion/styled'


export const PricingOuter = styled.div({
  padding: '56px 40px 40px',
  background: '#F5F5F5',
  borderRadius: 20,
  border: '1px solid #e9e8e8'

}, props => ({
}))

export const PricingTitle = styled.h2({
fontSize: 36,
fontWeight: 700,
lineHeight: '44px',
margin: '0 0 16px'
})

export const TotalCost = styled.div({
  fontSize: 68,
  fontWeight: 700,
  margin: '30px 0 0px'
})

export const FindOut = styled.div({
  fontWeight: 700,
  fontSize: 13,
  margin: '20px 0 70px',
  '& > a': {
    textDecoration: 'underline',
    color: '#0A141E'
  }
})

export const PrePurchase = styled.div({
  backgroundColor: '#E4F7EA',
  color: '#098032',
  borderTop: '1px solid #098032',
  borderBottom: '1px solid #098032',
  margin: '0 -40px',
  fontSize: 13,
  textAlign: 'center',
  padding: '12px 0',
})